import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { AcuerdosService } from '../acuerdos.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-acuerdos',
  templateUrl: './acuerdos.component.html',
  styleUrls: ['./acuerdos.component.scss']
})
export class AcuerdosComponent implements OnInit {

  datos: any[] = [];
  view_priv: any[] = [];
  view_priv_boolean: boolean = false;

  loading: boolean = false;
  constructor(
    public rest: RestService,
    public user: UserService,
    public acuerdosService: AcuerdosService
    ) {}

  ngOnInit() { }

  Actualizar() {
    this.acuerdosService.GetData();
    this.acuerdosService.GetFamilias();
  }

  Mostrar() {
    this.view_priv_boolean = !this.view_priv_boolean;
  }

  OcultarYMostrar(registry,index){
    registry.activo = index;
  }

  BorrarAcuerdo(v,index){
    const opcion = confirm('Estas seguro?');

    if ( opcion ) {
      this.rest.BorrarAcuerdo(v.id).subscribe(
        (data) => {
          this.datos.splice(index, 1);
          this.user.PublicMsg(data);
        },
        (error) => this.user.PublicError(error) );

    }

  }

  SetRegistry(registro) {
    this.view_priv_boolean = true;

    this.view_priv['desglose'] = registro.desglose;
    this.view_priv['articulo'] = registro.Nombre;
    this.view_priv['tpv5_total_comprado'] = registro.tpv5_total_comprado;

  }

  NoMostrar() { this.view_priv_boolean = false; }

}
